import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { EaStatusBar } from '../ea-status-bar/ea-status-bar';
import { EaStatus } from '../ea-status-bar/ea-status-bar.models';
import { DEFAULT_STATUS_BAR_DELAY_MS } from '../ea-status-bar/ea-status-bar.utils';

import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';

@Component({
    selector: 'ea-snackbar',
    imports: [EaStatusBar],
    templateUrl: './ea-snackbar.html',
    styleUrl: './ea-snackbar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: 'alert',
        'aria-live': 'polite',
    },
})
export class EaSnackbar {
    public readonly $id = input.required<string>();
    public readonly $message = input.required<string>();
    public readonly $statusType = input.required<EaStatus>();
    public readonly $delay = input<number>(DEFAULT_STATUS_BAR_DELAY_MS);

    private readonly _snackbarService = inject(SnackbarService);

    protected handleDelayElapsed(): void {
        this._snackbarService.hide(this.$id());
    }
}
